var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("common-layout", [
    _c("div", { staticClass: "top" }, [
      _c("div", { staticClass: "header" }, [
        _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.systemName))]),
      ]),
      _vm.showInput3 === false
        ? _c(
            "div",
            {
              staticClass: "boxes",
              staticStyle: { width: "100%", "margin-top": "200px" },
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://work.weixin.qq.com/wework_admin/commdownload?platform=win&from=baidu",
                  },
                },
                [
                  _c("div", { staticClass: "first big" }, [
                    _c("div", { staticClass: "small" }),
                    _c("span", [_vm._v("Windows桌面端")]),
                    _c("p", { staticClass: "p1" }, [_vm._v("点击直接下载")]),
                  ]),
                ]
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://work.weixin.qq.com/wework_admin/commdownload?platform=mac&from=baidu",
                  },
                },
                [
                  _c("div", { staticClass: "second big" }, [
                    _c("div", { staticClass: "small" }),
                    _c("span", [_vm._v("Mac桌面端")]),
                    _c("p", { staticClass: "p2" }, [_vm._v("点击直接下载")]),
                  ]),
                ]
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://work.weixin.qq.com/wework_admin/commdownload?platform=ios&from=baidu",
                  },
                },
                [
                  _c("div", { staticClass: "third big" }, [
                    _c("div", { staticClass: "small" }),
                    _c("span", [_vm._v("IOS版")]),
                    _c("p", { staticClass: "p3" }, [_vm._v("扫描二维码下载")]),
                  ]),
                ]
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://work.weixin.qq.com/wework_admin/commdownload?platform=android&from=baidu",
                  },
                },
                [
                  _c("div", { staticClass: "forth big" }, [
                    _c("div", { staticClass: "small" }),
                    _c("span", [_vm._v("Android版")]),
                    _c("p", { staticClass: "p4" }, [_vm._v("扫描二维码下载")]),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.showInput3 === false
        ? _c(
            "span",
            {
              staticStyle: {
                "margin-top": "100px",
                height: "20px",
                display: "block",
              },
            },
            [
              _vm._v("请使用 "),
              _c("span", { staticClass: "spana", on: { click: _vm.toHere1 } }, [
                _vm._v("企"),
              ]),
              _vm._v("业微信内个 "),
              _c("span", { staticClass: "spana", on: { click: _vm.toHere2 } }, [
                _vm._v("人"),
              ]),
              _vm._v("中心 "),
              _c("span", { staticClass: "spana", on: { click: _vm.toHere3 } }, [
                _vm._v("登"),
              ]),
              _vm._v("录 "),
            ]
          )
        : _vm._e(),
    ]),
    _vm.showInput3 === true
      ? _c(
          "div",
          { staticClass: "login" },
          [
            _c(
              "a-form",
              { attrs: { form: _vm.form }, on: { submit: _vm.onSubmit } },
              [
                _c(
                  "a-tabs",
                  {
                    staticStyle: { padding: "0 2px" },
                    attrs: {
                      size: "large",
                      tabBarStyle: { textAlign: "center" },
                    },
                  },
                  [
                    _c(
                      "a-tab-pane",
                      { key: "1", attrs: { tab: "账户密码登录" } },
                      [
                        _c("a-alert", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.error,
                              expression: "error",
                            },
                          ],
                          staticStyle: { "margin-bottom": "24px" },
                          attrs: {
                            type: "error",
                            closable: true,
                            message: _vm.error,
                            showIcon: "",
                          },
                        }),
                        _c(
                          "a-form-item",
                          [
                            _c(
                              "a-input",
                              {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "username",
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: "请输入账户名",
                                            whitespace: true,
                                          },
                                        ],
                                      },
                                    ],
                                    expression:
                                      "['username', {rules: [{ required: true, message: '请输入账户名', whitespace: true}]}]",
                                  },
                                ],
                                attrs: {
                                  autocomplete: "autocomplete",
                                  size: "large",
                                  placeholder: "请输入账户名",
                                },
                              },
                              [
                                _c("a-icon", {
                                  attrs: { slot: "prefix", type: "user" },
                                  slot: "prefix",
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-form-item",
                          [
                            _c(
                              "a-input",
                              {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "password",
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: "请输入密码",
                                            whitespace: true,
                                          },
                                        ],
                                      },
                                    ],
                                    expression:
                                      "['password', {rules: [{ required: true, message: '请输入密码', whitespace: true}]}]",
                                  },
                                ],
                                attrs: {
                                  size: "large",
                                  placeholder: "请输入密码",
                                  autocomplete: "autocomplete",
                                  type: "password",
                                },
                              },
                              [
                                _c("a-icon", {
                                  attrs: { slot: "prefix", type: "lock" },
                                  slot: "prefix",
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-form-item",
                          [
                            _c("a-input", {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: [
                                    "code",
                                    {
                                      rules: [
                                        {
                                          required: true,
                                          message: "请输入验证码",
                                          whitespace: true,
                                        },
                                      ],
                                    },
                                  ],
                                  expression:
                                    "['code', {rules: [{ required: true, message: '请输入验证码', whitespace: true}]}]",
                                },
                              ],
                              staticStyle: { width: "60%" },
                              attrs: {
                                size: "large",
                                placeholder: "请输入验证码",
                                autocomplete: "autocomplete",
                                type: "text",
                              },
                            }),
                            _c("div", { staticClass: "login-code" }, [
                              _c("img", {
                                staticClass: "login-code-img",
                                attrs: { src: _vm.codeUrl },
                                on: { click: _vm.getCode },
                              }),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  [
                    _c(
                      "a-button",
                      {
                        staticStyle: { width: "100%", "margin-top": "24px" },
                        attrs: {
                          loading: _vm.logging,
                          size: "large",
                          htmlType: "submit",
                          type: "primary",
                        },
                      },
                      [_vm._v("登录 ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }